import IMessage from "../../shared/interfaces/message.interface";

export const MESSAGE_CANCEL_QUOTAS: IMessage = {
    textMessage: "Perfecto, se han cerrado los cupos correctamente",
    style: "success",
    open: '',
    duration: 3000
}

export const MESSAGE_ADD_QUOTAS: IMessage = {
    textMessage: "Perfecto, se han activado los cupos correctamente",
    style: "success",
    open: '',
    duration: 3000
}

export const MESSAGE_DEFAULT: IMessage = {
    textMessage: "",
    style: "success",
    open: '',
    duration: 3000
}